import styled from 'styled-components';

import { Toast, token } from '@zillow/constellation';
import { Container } from '@zillow/zrs-comet';

export const StyledToast = styled(Toast)`
    max-width: unset;
`;

export const StyledContainer = styled(Container)`
    border: 1px solid ${token('colors.gray300')};
    border-radius: 5px;
`;
